<script>
import PromoteProduct from './PromoteProduct.vue'

export default {
  name: 'PromoteLive',
  extends: PromoteProduct,
}
</script>
